import React, { useEffect } from 'react';

import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

const FieldText = ({
  disabled,
  maxLength,
  name,
  placeholder,
  label,
  className,
  classInvalid,
  onChangeCallback,
  required,
  valueDefinied,
  hidden,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();

  const onChange = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setFieldValue(name, value);
    onChangeCallback(value);
  };

  useEffect(() => {
    if (valueDefinied) {
      setFieldValue(name, valueDefinied);
    }
  }, [valueDefinied]);

  return (
    <div className={className} hidden={hidden}>
      <label htmlFor={name}>
        {label}
        {required && <span className="color-red">&nbsp;*</span>}
      </label>
      {errors[name] && touched[name] && <div className={classInvalid}>{errors[name]}</div>}
      {!errors[name] && touched[name] && <div className="field-valid">ok</div>}
      <Field
        disabled={disabled}
        name={name}
        value={values[name] || valueDefinied}
        type="text"
        placeholder={placeholder}
        onChange={onChange}
        maxLength={maxLength} />
    </div>
  );
};

FieldText.defaultProps = {
  required: false,
  placeholder: '',
  className: 'field -input',
  classInvalid: 'field-invalid',
  disabled: false,
  onChangeCallback: () => { },
  maxLength: 50,
  valueDefinied: '',
  hidden: false,
};

FieldText.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChangeCallback: PropTypes.func,
  required: PropTypes.bool,
  classInvalid: PropTypes.string,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
  valueDefinied: PropTypes.string,
  hidden: PropTypes.bool,
};

export default FieldText;
